import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSignupRole } from '../../redux/slices/signupSlice';
import BackButton from '../BackButton/BackButton';
import AuthSwitchLink from '../AuthSwitchLink/AuthSwitchLink';
import Dropdown from '../Dropdown/Dropdown'; 
import styles from './RoleSelect.module.css';

const allRoleOptions = [
  { value: 'athlete', label: 'Athlete' },
  { value: 'coach', label: 'Coach' },
  { value: 'admin', label: 'Admin' }
];

const signupRoleOptions = allRoleOptions.filter(
  (option) => option.value !== 'admin'
);

const RoleSelect = () => {
  const [selectedRole, setSelectedRole] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoginFlow = location.pathname.startsWith('/login');

  const roleOptions = isLoginFlow ? allRoleOptions : signupRoleOptions;

  const handleContinue = () => {
    if (!selectedRole) return;

    if (isLoginFlow) {
      navigate(`/login/enter-credentials?role=${selectedRole}`);
    } else {
      const nextStep =
        selectedRole === 'athlete'
          ? `/signup/select-sport?role=${selectedRole}`
          : `/signup/enter-credentials?role=${selectedRole}`;
      navigate(nextStep);
    }
  };

  return (
    <div className={styles.wrapper}>
      <BackButton />
      <h2 className={styles.heading}>Select Your Role</h2>
      <Dropdown
        options={roleOptions}
        value={selectedRole}
        onChange={(val) => {
          setSelectedRole(val);
          dispatch(setSignupRole(val));
        }}
        placeholder="Choose a role..."
      />
      <button
        className={`${styles.continueBtn} ${!selectedRole ? styles.disabled : ''}`}
        onClick={handleContinue}
        disabled={!selectedRole}
      >
        Continue
      </button>
      <AuthSwitchLink />
    </div>
  );
};

export default RoleSelect;